module.exports = __webpack_public_path__ + "static/media/it-ticketing-system.0a842203.png";